import type { FaireProductEntity } from "../../entity_types/product";

export const p_cx7cg8yrkf: FaireProductEntity = {
  token: "p_cx7cg8yrkf",
  type: "product",
  name: "Sample Products Only - Try Before You Buy! ( Read Listing )",
  brandToken: "b_tguegdbkxr",
  brandName: "Beautique Goals",
  imageUrl:
    "https://cdn.faire.com/fastly/8713c9cecf907652e126026cc5ebb3158ca083e35f727ff930b8741eaa91e9f0.jpeg",
  galleryImageUrls: [],
  priceDollars: 3,
  description:
    "\nNot sure which products are right for you? Our samples listing is perfect for testing out different items before committing to a full-size purchase! The promotion helps even more!\n\nWhat's Included:\nThis listing includes a variety of sample-sized products from our range, including:\nBody butters, glazes, and creams - 1oz\nMakeup samples - 5ml or 15ml\nFood samples - Depends\nOils and perfumes - 15ml\nCandles and soaps - 2oz\nHair sprays - 1oz\nMoisturizers and lotions - 1oz\nBalms and masks - 1oz\nSoaks and bath products - 1oz\nTeas - 5 bags\nSerums - 15ml or 1oz\nDeodorants - 1oz\nAnd more!\n\nCustom Options:\nWant specific products or a custom mix? Let us know or we can mix for you! Add your preferred products to the custom section of this listing or message us with your requests. We'll do our best to accommodate your needs. We add sample to each, no logo's or names.\n\nBenefits:\nFinding new favorite products\nMix and match to create your perfect set\nPerfect for individuals desiring a little bit of variety without much risk or breaking the bank",
  tags: [],
  msrpDollars: 6,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-25T20:50:38.677Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
